/** @jsxImportSource @emotion/react */
import { useState, useEffect, useRef } from "react";
import { useParams } from "react-router-dom";
import {
  accessAPI,
  Titulo,
  Formulario,
  CampoInformacion,
  Boton
} from "../../../shared/index.js";
import CardLogo from "./CardLogo.js";
import CardEmpleados from "./CardEmpleados.js";
import CardUsuarios from "./CardUsuarios.js";
import { Card } from "primereact/card";
import { Sidebar, tituloBase } from "../../../shared";
import { Toast } from "primereact/toast";
import { Divider } from "primereact/divider";
import { Skeleton } from "primereact/skeleton";
import { ConfirmDialog } from "primereact/confirmdialog";

export default function ClienteInformacion() {
  const [loader, setLoader] = useState(true);
  const [cliente, setCliente] = useState();
  const [sidebarEditarVisible, setSidebarEditarVisible] = useState(false);
  const [loaderEditar, setLoaderEditar] = useState(false);

  const toast = useRef(null);
  const { clienteId } = useParams();

  function cargarCliente() {
    accessAPI(
      "GET",
      `admin/cliente/${clienteId}`,
      null,
      (respuesta) => {
        setCliente(respuesta);
        setLoader(false);
        document.title = respuesta.razonsocial;
      },
      (respuesta) => {
        toast.current?.show({
          severity: "error",
          summary: "Error",
          detail: respuesta?.[0]?.msg || "Error en la operación",
          sticky: true
        });
      }
    );
  }

  useEffect(() => {
    if (clienteId) cargarCliente();
    return () => (document.title = tituloBase());
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [clienteId]);

  function handleEmpleadoCreado(respuesta) {
    setCliente({
      ...cliente,
      empleadoclientes: [...cliente.empleadoclientes, respuesta[0].empleado]
    });
  }

  function handleEmpleadoEditado(empleadoActualizado) {
    setCliente({
      ...cliente,
      empleadoclientes: cliente.empleadoclientes.map((e) =>
        e.id === empleadoActualizado.id ? empleadoActualizado : e
      )
    });
  }

  function handleEmpleadoEliminado(empleadoId) {
    setCliente({
      ...cliente,
      empleadoclientes: cliente.empleadoclientes.filter(
        (e) => e.id !== empleadoId
      )
    });
  }

  function handleUsuarioCreado(nuevoUsuario) {
    setCliente({
      ...cliente,
      Usuario_x_Acceso: [...cliente.Usuario_x_Acceso, nuevoUsuario]
    });
  }

  function handleUsuarioEditado(usuarioActualizado) {
    setCliente({
      ...cliente,
      Usuario_x_Acceso: cliente.Usuario_x_Acceso.map((u) =>
        u.usuario.id === usuarioActualizado.usuario.id ? usuarioActualizado : u
      )
    });
  }

  function handleUsuarioAccesoEliminado(usuarioAccesoId) {
    setCliente({
      ...cliente,
      Usuario_x_Acceso: cliente.Usuario_x_Acceso.filter(
        (u) => u.id !== usuarioAccesoId
      )
    });
  }

  function handleUsuarioEliminadoCompleto(usuarioId) {
    setCliente({
      ...cliente,
      Usuario_x_Acceso: cliente.Usuario_x_Acceso.filter(
        (u) => u.usuario.id !== usuarioId
      )
    });
  }

  function editarEmpresaSubmit(formData) {
    setLoaderEditar(true);
    accessAPI(
      "PUT",
      `admin/cliente/${cliente.id}`,
      formData,
      () => {
        setLoaderEditar(false);
        setSidebarEditarVisible(false);
        setCliente({ ...cliente, ...formData });
      },
      (respuesta) => {
        setLoaderEditar(false);
        toast.current?.show({
          severity: "error",
          summary: "Error",
          detail: respuesta?.[0]?.msg || "Error en la operación",
          sticky: true
        });
      }
    );
  }

  const editarEmpresaFormConfig = cliente
    ? {
        secciones: [
          {
            nombre: "Editar datos",
            campos: [
              { nombre: "razonsocial", tipoitemformularioid: 1, etiqueta: "Razón social", requerido: true, respuesta: cliente.razonsocial },
              { nombre: "nombrefantasia", tipoitemformularioid: 1, etiqueta: "Nombre fantasía", respuesta: cliente.nombrefantasia },
              { nombre: "rut", tipoitemformularioid: 1, etiqueta: "Identificador", respuesta: cliente.rut },
              {
                nombre: "tipoIdentificadorId",
                tipoitemformularioid: 5,
                etiqueta: "Tipo",
                opciones: "admin/config/tipoidentificador?dropdown=true",
                respuesta: cliente.tipoIdentificadorId,
                sinOpcionInicial: true
              },
              { nombre: "telefono", tipoitemformularioid: 1, etiqueta: "Teléfono", respuesta: cliente.telefono },
              { nombre: "pagina", tipoitemformularioid: 1, etiqueta: "Página", respuesta: cliente.pagina },
              { nombre: "notas", tipoitemformularioid: 11, etiqueta: "Notas", respuesta: cliente.notas }
            ]
          }
        ],
        botones: [
          {
            etiqueta: "Guardar cambios",
            callback: editarEmpresaSubmit,
            validar: true
          }
        ]
      }
    : null;

  if (loader || !cliente) {
    return (
      <>
        <Toast ref={toast} position="top-center" />
        <Skeleton
          width="20rem"
          height="2rem"
          css={{ marginTop: "2em", marginBottom: "1em" }}
        />
        <div className="grid">
          <div
            className="col-12 lg:col-6"
            css={{ display: "flex", flexDirection: "column", gap: "1em" }}
          >
            <Card>
              <Skeleton width="200px" height="1.5rem" css={{ marginBottom: "1.5em" }} />
              <div css={{ display: "flex", flexWrap: "wrap", gap: "1em" }}>
                {[...Array(8)].map((_, i) => (
                  <div key={i} css={{ width: "45%" }}>
                    <Skeleton width="80px" height="0.8rem" css={{ marginBottom: "0.3em" }} />
                    <Skeleton width="100%" height="1.2rem" />
                  </div>
                ))}
              </div>
            </Card>
            <Card>
              <Skeleton width="100px" height="1.5rem" css={{ marginBottom: "1em" }} />
              <div css={{ display: "flex", justifyContent: "center" }}>
                <Skeleton width="150px" height="150px" />
              </div>
            </Card>
          </div>
          <div
            className="col-12 lg:col-6"
            css={{ display: "flex", flexDirection: "column", gap: "1em" }}
          >
            <Card>
              <Skeleton width="150px" height="1.5rem" css={{ marginBottom: "1em" }} />
              {[...Array(3)].map((_, i) => (
                <Skeleton key={i} width="100%" height="2.5rem" css={{ marginBottom: "0.5em" }} />
              ))}
            </Card>
            <Card>
              <Skeleton width="120px" height="1.5rem" css={{ marginBottom: "1em" }} />
              {[...Array(3)].map((_, i) => (
                <Skeleton key={i} width="100%" height="2.5rem" css={{ marginBottom: "0.5em" }} />
              ))}
            </Card>
          </div>
        </div>
      </>
    );
  }

  return (
    <>
      <Toast ref={toast} position="top-center" />
      <ConfirmDialog />
      <Titulo
        etiquetas={[
          ...(cliente?.clasificaciones || [])
            .filter((c) => c.etiqueta)
            .map((c) => ({ texto: c.etiqueta })),
          ...(cliente?.facturara ? [{ texto: "Factura a otra empresa" }] : [])
        ]}
      >
        {cliente?.razonsocial || "Cliente"} - Información
      </Titulo>

      <Sidebar
        visible={sidebarEditarVisible}
        position="right"
        onHide={() => setSidebarEditarVisible(false)}
        className="w-full lg:w-30rem md:w-30rem"
      >
        {editarEmpresaFormConfig && (
          <Formulario config={editarEmpresaFormConfig} loader={loaderEditar} />
        )}
      </Sidebar>

      {cliente && (
        <div className="grid">
          <div
            className="col-12 lg:col-6"
            css={{ display: "flex", flexDirection: "column", gap: "1em" }}
          >
            <Card>
              <Titulo
                botones={
                  <Boton
                    texto
                    negro
                    chico
                    callback={() => setSidebarEditarVisible(true)}
                  >
                    <i className="pi pi-pencil" />
                  </Boton>
                }
              >
                Información de la empresa
              </Titulo>
              <div css={{ display: "flex", flexWrap: "wrap" }}>
                <CampoInformacion nombreCampo="Razón social">{cliente.razonsocial}</CampoInformacion>
                <CampoInformacion nombreCampo="Nombre fantasía">{cliente.nombrefantasia}</CampoInformacion>
                <CampoInformacion nombreCampo="Identificador">{cliente.rut}</CampoInformacion>
                <CampoInformacion nombreCampo="Tipo">
                  {cliente.tipoIdentificador?.nombre || "-"}
                </CampoInformacion>
                <CampoInformacion nombreCampo="Página web">{cliente.pagina}</CampoInformacion>
                {(() => {
                  const sede = cliente.sitios?.find((s) => s.headquarters);
                  return (
                    <>
                      <Divider />
                      <CampoInformacion nombreCampo="Dirección">{sede?.direccion || cliente.direccion}</CampoInformacion>
                      <CampoInformacion nombreCampo="Código postal">{sede?.codigoPostal || cliente.codigopostal}</CampoInformacion>
                      <CampoInformacion nombreCampo="Estado">{sede?.estado || cliente.estado}</CampoInformacion>
                      <CampoInformacion nombreCampo="Ciudad">{sede?.ciudad || cliente.ciudad}</CampoInformacion>
                      <CampoInformacion nombreCampo="País">{sede?.pais || cliente.pais}</CampoInformacion>
                    </>
                  );
                })()}
                <CampoInformacion nombreCampo="Teléfono">{cliente.telefono}</CampoInformacion>
                <Divider />
                <CampoInformacion nombreCampo="Notas" anchoCompleto>
                  <span css={{ whiteSpace: "pre-wrap" }}>{cliente.notas}</span>
                </CampoInformacion>
              </div>
            </Card>
            <CardLogo clienteId={cliente.id} />
          </div>

          <div
            className="col-12 lg:col-6"
            css={{ display: "flex", flexDirection: "column", gap: "1em" }}
          >
            <CardEmpleados
              empleados={cliente.empleadoclientes}
              clienteId={cliente.id}
              onEmpleadoCreado={handleEmpleadoCreado}
              onEmpleadoEditado={handleEmpleadoEditado}
              onEmpleadoEliminado={handleEmpleadoEliminado}
            />
            <CardUsuarios
              usuarios={cliente.Usuario_x_Acceso}
              empleadosPendientes={(cliente.empleadoclientes || []).filter(
                (e) => e.usuario && e.usuario.aprobado === false
              )}
              clienteId={cliente.id}
              onUsuarioCreado={handleUsuarioCreado}
              onUsuarioEditado={handleUsuarioEditado}
              onUsuarioAccesoEliminado={handleUsuarioAccesoEliminado}
              onUsuarioEliminadoCompleto={handleUsuarioEliminadoCompleto}
              onUsuarioAprobado={cargarCliente}
            />
          </div>
        </div>
      )}
    </>
  );
}
